<script>
import {h, resolveComponent} from 'vue';

const TAG_LABEL = 'legoTabLabel';
const TAG_CONTS = 'legoTabContent';
const TYPE_LABEL = 'label';
const TYPE_LEFT = 'left';
const TYPE_RIGHT = 'right';

export default {
  name: 'lego-core-tab-box',
  emits: ['tab-change'],
  data: function () {
    return {
      currIdx: '3',
      leftIcon: 'chevron-left',
      rightIcon: 'chevron-right',
      titleObj: {},
      offset: 0,
      tabNaviLabelStyle: 'none',
      tabNaviClass: 'lego-tab__navi',
      ele: null
    };
  },
  props: {
    mini: Boolean,
    defaultIdx: [String, Number],
    underline: {type: Boolean, default: false}
  },
  created() {
    // 1. Check default index
    if (this.defaultIdx) {
      this.currIdx = this.defaultIdx;
      return;
    }
    // 2. Make first tab to current tab
    let slots = this.$slots.default(),
        idxs = [];
    slots.forEach((vNode) => {
      if (!vNode.type) {
        return;
      }
      let nodeName = vNode.type.name;
      if (TAG_LABEL === nodeName) {
        idxs.push(vNode.props.idx);
      }
    });
    this.currIdx = idxs[0];
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.$refs.tab.className === 'lego-tab__title') {
        //let scrollWidth = this.$el.children[0].children[0].scrollWidth;
        //let clientWidth = this.$el.children[0].children[0].clientWidth;
        // if(scrollWidth >= clientWidth) {
        //     this.tabNaviLabelStyle = "inline-block";
        // } else {
        //     this.tabNaviLabelStyle = "none"
        // }
        this.tabNaviLabelStyle = 'none';
        //this.tabNaviLabelStyle = "flex";
      }
    });
  },
  render(props) {
    const vProps = props;
    let slots = vProps.$slots.default();
    let labels = [],
        conts = [],
        navi = [];
    let idxs = [];
    // 1. classify nodes
    slots.forEach((vNode) => {
      if (!vNode.type) {
        return;
      }
      let nodeName = vNode.type.name;
      switch (nodeName) {
        case TAG_LABEL:
          labels.push(vNode);
          let propsData = vNode.props;
          vNode.props = Object.assign({}, propsData, {
            mini: vProps.mini,
            type: TYPE_LABEL,
            onActiveIdx: vProps.setIdx
          });

          break;
        case TAG_CONTS:
          let props = vNode.props;
          let label = props.label,
              idx = props.idx;
          if (label) {
            const legoTabLabel = resolveComponent('lego-tab-label');
            let pseudo = h(
                legoTabLabel,
                {idx, mini: vProps.mini, type: TYPE_LABEL, onActiveIdx: vProps.setIdx},
                [label]
            );
            labels.push(pseudo);
          }
          conts.push(vNode);
          break;
      }
    });
    // 2. tab navi
    if (vProps.mini) {
      vProps.tabNaviClass = 'lego-tab__navi--mini';
    }
    // 2.1. left tab
    const legoTabLabel = resolveComponent('lego-tab-label');
    let leftTabNavi = h(legoTabLabel);
    let leftTabNaviPropsData = leftTabNavi.props;
    leftTabNavi.props = Object.assign({}, leftTabNaviPropsData, {
      mini: vProps.mini,
      icon: vProps.leftIcon,
      type: TYPE_LEFT,
      onMove: vProps.move
    });
    navi.push(leftTabNavi);
    // 2.2. right tab
    let rightTabNavi = h(legoTabLabel);
    let rightTabNaviPropsData = rightTabNavi.props;
    rightTabNavi.props = Object.assign({}, rightTabNaviPropsData, {
      mini: vProps.mini,
      icon: vProps.rightIcon,
      type: TYPE_RIGHT,
      onMove: vProps.move
    });
    navi.push(rightTabNavi);

    return h('div', {class: 'lego-tab-box'}, [
      h('div', {class: 'lego-tab__label-window'}, [
        h(
            'div',
            {
              class: 'lego-tab__label-wrapper',
              style: 'margin-left:' + vProps.offset + 'px',
              ref: 'tab'
            },
            labels
        ),
        h('div', {class: 'lego-tab__navi', style: 'display:' + vProps.tabNaviLabelStyle}, navi)
      ]),
      h('div', {class: 'lego-tab__content-wrapper'}, conts)
    ]);
  },
  methods: {
    setIdx(idx) {
      this.currIdx = idx;
      this.$emit('tab-change', idx);
    },
    move(direction) {
      if (this.$refs.tab.className === 'lego-tab__title') {
        let scrollWidth = this.$refs.tab.scrollWidth;
        let clientWidth = this.$refs.tab.clientWidth;

        if (direction === 'left') {
          if (this.offset < 0) {
            if (this.offset >= -200) {
              this.offset = 0;
            } else {
              this.offset += 200;
            }
          }
        } else if (direction === 'right') {
          let var1 = clientWidth - scrollWidth;
          if (this.offset <= 0 && var1 < 0) {
            if (var1 >= -200) {
              this.offset += var1;
            } else {
              this.offset -= 200;
            }
          }
        }
      }
    }
  },
  provide() {
    return {
      tabBox: {
        underline: this.underline
      }
    };
  }
};
</script>
